import {
  createRootRoute,
  createRoute,
  Outlet,
  redirect,
} from "@tanstack/react-router";
import { ConsoleNotFound, ConsoleShell } from "./ConsoleShell";
import { RecordsRoute } from "./RecordsRoute";

/**
 * Spec §3.2: /console and /console/records (and any deep path) are all
 * served by the same SPA shell, so the client-side router must match
 * `/console` and `/console/records` independently of the Vite asset base.
 */
const rootRoute = createRootRoute({
  component: () => <Outlet />,
});

const consoleRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "console",
  component: ConsoleShell,
  notFoundComponent: ConsoleNotFound,
});

const consoleIndexRoute = createRoute({
  getParentRoute: () => consoleRoute,
  path: "/",
  beforeLoad: () => {
    throw redirect({ to: "/console/records", replace: true });
  },
});

const consoleRecordsRoute = createRoute({
  getParentRoute: () => consoleRoute,
  path: "records",
  component: RecordsRoute,
});

const recordsIndexRoute = createRoute({
  getParentRoute: () => consoleRecordsRoute,
  path: "/",
});

const recordDetailRoute = createRoute({
  getParentRoute: () => consoleRecordsRoute,
  path: "$recordId",
});

export const routeTree = rootRoute.addChildren([
  consoleRoute.addChildren([
    consoleIndexRoute,
    consoleRecordsRoute.addChildren([recordsIndexRoute, recordDetailRoute]),
  ]),
]);
